import { Component } from '@angular/core';
import { AuthService, StateService, ThemeService } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICompany, ListManufacturersRequest, CopyThemeRequest, CopyThemeResponse, SituViewWebApiClient, Theme } from 'situview-webapi-client';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Company } from 'identity-webapi-client';

@Component({
  selector: 'themes-copy',
  templateUrl: './themes-copy.component.html',
  styleUrls: ['./themes-copy.component.scss']
})

export class ThemesCopyComponent extends SituBaseComponent {
  sourceThemeId?: string;
  sourceThemes?: Theme[];
  
  destinationCompanyId?: string;
  destinationThemeName?: string;

  allowOverwritingExistingTheme = false;

  allCompanies?: Company[];

  errorMessage?: string;
  
  constructor(
    authService: AuthService,
    stateService: StateService,
    private situViewClient: SituViewWebApiClient,
    private router: Router,
    private snackBar: MatSnackBar,
    private situViewWebApiClient: SituViewWebApiClient,
    private themeService: ThemeService) {
    super(authService, stateService);

    this.loadCompanies();
  }

  protected onSelectedCompanyChange(): void {
    this.destinationCompanyId = this.selectedCompany?.id!;
    this.loadThemes();
  }

  loadThemes() {
    this.themeService.LoadThemes(this.selectedCompany?.id!)
      .then((themes: Theme[]) => {
        this.sourceThemes = themes;
      })
      .catch((error: any) => {
        this.showMessage("There was an issue loading themes. Please refresh the page to try again.");
      });
  }

  loadCompanies() {
    let request = new ListManufacturersRequest();

    return this.situViewWebApiClient.listManufacturers(request)
    .then(response => {
      this.allCompanies = response.manufacturers;
    });
  }

  onSourceThemeIdChange() {
    var theme = this.getTheme(this.sourceThemeId!);
    this.destinationThemeName = `${theme?.name} Copy`;
  }

  getTheme(themeId: string) : Theme | undefined {
    return this.sourceThemes?.find(x => x.id === themeId);
  }

  copyTheme() {
    var sourceTheme = this.getTheme(this.sourceThemeId!);
    var request = new CopyThemeRequest();
    request.sourceCompanyId = this.selectedCompany?.id;
    request.sourceThemeName = sourceTheme?.name;
    request.destinationCompanyId = this.destinationCompanyId;
    request.destinationThemeName = this.destinationThemeName;
    request.allowOverwritingExistingTheme = this.allowOverwritingExistingTheme;
    return this.situViewClient.copyTheme(request)
      .then((response: CopyThemeResponse) => {
        if (response.success) {
          this.showMessage(`The theme ${sourceTheme?.name} has been copied to to ${this.selectedCompany?.name}.`);
          var createdForDifferentCompany = this.selectedCompany?.id !== this.destinationCompanyId;

          this.themeService.ClearLoadedThemesCache();

          if (createdForDifferentCompany)
          {
            this.router.navigate(['/homes/themes']);
          } else {
            this.router.navigate(['/homes/themes', response.theme!.companyId, response.theme!.id]);
          }
        } else {
          this.errorMessage = response?.errorMessages![0];
          this.showMessage(this.errorMessage);
        }
      })
      .catch((err) => {
        this.showMessage("Sorry! There was an issue creating the new theme.");
      });
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }
}